import CommentContext from '@/context/apps/comment/CommentContext';
import React, { useContext, useRef, useState } from 'react';

import { useCommentListQuery } from '@/apis/comment/comment.query';

import usePagination from '@/hooks/shared/usePagination';
import useScrollToTarget from '@/hooks/shared/useScrollToTarget';

import Spinner from '../loading/Spinner';
import Pagination from '../pagination/Pagination';
import ReplyList from './ReplyList';

export default function ReplySection() {
  const context = useContext(CommentContext);
  if (!context) {
    throw new Error('Cannot find CommentContext');
  }
  const { foreignIdx } = context;

  const [page, setPage] = useState<number>(1);

  /** 페이지네이션 이동 후 위치할 스크롤 타겟 */
  const target = useRef<HTMLDivElement>(
    null,
  ) as React.MutableRefObject<HTMLDivElement>;

  const { moveToTargetHandler } = useScrollToTarget({ target: target });

  const { data: commentData, isLoading } = useCommentListQuery({
    params: {
      category: 'bc',
      foreignIdx: String(foreignIdx),
      take: 10,
      page: page,
    },
    useQueryOptions: {
      enabled: Boolean(foreignIdx),
      keepPreviousData: true,
    },
  });

  const { paginationData } = usePagination({
    data: commentData,
  });

  return (
    <>
      {/* 댓글 */}
      <div className="flex flex-col gap-6">
        <p ref={target} className="text-base font-medium leading-[150%]">
          댓글
          <span className="ml-[5px]">{commentData?.total ?? 0}</span>
        </p>

        {isLoading ? (
          <Spinner variant="apps" />
        ) : (
          <div className="flex flex-col gap-10">
            <ReplyList data={commentData} />
            {commentData && commentData?.results.length > 0 && (
              <Pagination
                forcePage={Number(paginationData.currentPage)} // 현재 페이지
                pageCount={Number(paginationData.pageCount)} // 총 페이지 수
                pageRange={5} // 페이지를 보여줄 범위
                onPageChangeHandler={({ selected }) => {
                  moveToTargetHandler();
                  setPage(selected + 1);
                }}
              />
            )}
          </div>
        )}
        {/* 댓글 목록 영역 */}
      </div>
    </>
  );
}

